import deleteAsset from './delete-asset';
import deleteSiteMeta from './delete-site-meta';
import setSiteMeta from './set-site-meta';
import setAsset from './set-asset';

export default {
  deleteAsset,
  deleteSiteMeta,
  setSiteMeta,
  setAsset,
};
